'use client';

import { toast } from 'sonner';

import { Button } from '../../components/button';

interface ArticleSectionShareProps {
	sectionId: string;
}

/**
 * ArticleSectionShare — a `#` anchor that copies a deep link to an article
 * section's heading. Shared by the docs and blog article renderers.
 *
 * The parent `<section>` controls reveal (opacity on hover/focus); this button
 * never sets its own visibility classes.
 */
export const ArticleSectionShare = ({ sectionId }: ArticleSectionShareProps): React.JSX.Element => {
	const handleClick = (): void => {
		const url = `${window.location.origin}${window.location.pathname}#${sectionId}`;
		void navigator.clipboard.writeText(url);
		toast.success('Link to section copied to clipboard');
		history.replaceState(null, '', `#${sectionId}`);
	};

	return (
		<Button
			variant="ghost"
			size="sm"
			iconOnly
			aria-label="Copy link to this section"
			onClick={handleClick}
		>
			#
		</Button>
	);
};
